<!-- ALERT TOAST-->
<p-toast></p-toast>

<!-- CONFIRMATION DIALOG-->
<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>

<!-- OVERLAY SCREEN -->
<div *ngIf="blocked" class="overlay">
    <img src="assets/layout/images/tovlogo.png" alt="Loading Icon" class="loading-image" />
    <span style="color: white; font-size: large;">{{translations.lbl_loading}}</span>
</div>

<!-- MAIN SCREEN -->
<div class="cinema-mode" *ngIf="translations && globalUserPreferencesParams?.storeId != null">

    <!-- CARD -->
    <ng-template #infoTemplateCreate [formGroup]="globalUserDataFormParams">

        <!-- GUIDE INFO -->
        <div class="subTitle p-d-flex p-ai-center p-jc-between p-py-2">
            <span>{{ translations.lbl_guide }}</span>
            <ng-container *ngIf="globalUserDataFormParams.get('selectedGuide').value != null; else noSelectionGuide">
                <span class="p-text-bold">
                    {{ globalUserDataFormParams.get('selectedGuide').value || " " }}</span>
            </ng-container>

            <ng-template #noSelectionGuide>
                <span class="p-text-bold">{{ translations.lbl_without + ' ' + translations.lbl_guide}}</span>
            </ng-template>
        </div>

        <!-- COORDINATION INFO -->
        <div class="subTitle p-d-flex p-ai-center p-jc-between p-py-2">
            <span>{{ translations.lbl_coordination }}</span>
            <ng-container
                *ngIf="globalUserDataFormParams.get('selectedCoordination').value != null; else noSelectionCoordination">
                <span class="p-text-bold">
                    {{ globalUserDataFormParams.get('selectedCoordination').value || " " }}</span>
            </ng-container>

            <ng-template #noSelectionCoordination>
                <span class="p-text-bold">{{ translations.lbl_without + ' ' + translations.lbl_coordination }}</span>
            </ng-template>
        </div>

        <!-- NAME INFO -->
        <div class="subTitle p-d-flex p-ai-center p-jc-between p-py-2">
            <span>{{ translations.lbl_name }}</span>
            <ng-container *ngIf="name != null; else noSelectionName">
                <span class="p-text-bold">
                    {{ name || " " }}</span>
            </ng-container>

            <ng-template #noSelectionName>
                <span class="p-text-bold">{{ translations.lbl_without + ' ' + translations.lbl_name }}</span>
            </ng-template>
        </div>
    </ng-template>

    <div class="video-container">


        <div class="video-wrapper">
            <div id="player" style="width:100%;height:100%"></div>
            <div class="overlay"></div>
        </div>

        <div class="controls">
            <button (click)="play()">▶️ Reproducir</button>
            <button (click)="pause()">⏸️ Pausar</button>
            <button (click)="forward(10)">⏩ +10s</button>
            <button (click)="backward(10)">⏪ -10s</button>
            <button (click)="toggleMute()">🔇 Desactivar/Activar Audio</button>

            <button pButton pRipple label="{{translations.lbl_go_Back}}" icon="pi pi-chevron-left"
                class="p-button-warning p-mr-2 p-mb-2" (click)="goBack()"></button>
            <button pButton type="button" [label]="blockedButton ? 'Descargando ...' : 'Descargar'"
                class="p-button-success p-mr-2 p-mb-2"
                [disabled]="blockedButton || blockedButton360fps || blockedButton720fps" (click)="downloadVideo()">
            </button>

            <div class="volume-control">
                <label>Volumen</label>
                <input type="range" min="0" max="100" step="1" (input)="setVolume($event)">
            </div>
        </div>
    </div>
</div>

<!-- OVERLAY SCREEN NO STORE ID -->
<div *ngIf="globalUserPreferencesParams?.storeId == null" class="overlay">
    <img src="assets/layout/images/tovlogo.png" alt="Loading Icon" class="loading-image" />
    <span style="color: white; font-size: large;">Verifica sesión e intenta más tarde...</span>
</div>